module.exports = __webpack_public_path__ + "static/img/wifi.52ae933d.png";